import { createApi } from '@reduxjs/toolkit/query/react';
import   {appBaseQuery} from "../services/baseQuery"


export const inventoryApi = createApi({
  reducerPath: 'inventoryApi',
   baseQuery:appBaseQuery,
  tagTypes: ['Inventory'],
  endpoints: (builder) => ({
    // GET (List)
    getInventory: builder.query({
      query: ({ page = 1, limit = 10 }) =>
        `inventory/?page=${page}&limit=${limit}`,
      providesTags: ['Inventory'],
    }),

    // POST 
    addInventory: builder.mutation({
      query: (newItem) => ({
        url: 'inventory/',
        method: 'POST',
        body: newItem,
      }),
      invalidatesTags: ['Inventory'],
    }),

    // PUT 
    updateInventory: builder.mutation({
      query: ({ uid, ...updatedData }) => ({
        url: `inventory/${uid}`,
        method: 'PUT',
        body: updatedData,
      }),
      invalidatesTags: ['Inventory'],
    }),

    // DELETE 
    deleteInventory: builder.mutation({
      query: (uid) => ({
        url: `inventory/${uid}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Inventory'],
    }),
  }),
});

export const {
  useGetInventoryQuery,
  useAddInventoryMutation,
  useUpdateInventoryMutation,
  useDeleteInventoryMutation,
} = inventoryApi;
